import MultiPageLayout from "layout/MultiPageLayout";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { useLazyGetRedirectQuery } from "service/APIService";

const PublicRoute = ({ layout, children }) => {
  const location = useLocation();
  const [redirectData] = useLazyGetRedirectQuery();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (
      ["/auth", "/test-page", "/logout", "/learning-page"].indexOf(
        location?.pathname
      ) < 0 &&
      !params.get("oneTimeToken")
    ) {
      redirectData({
        state: params.get("state") || crypto.randomUUID(),
        idp: params.get("idp") || "",
        idphint: params.get("idphint") || "",
      })
        .unwrap()
        .then((res) => {
          window.location.href = res;
        });
    }
  }, [location]);

  if (layout === "MultiPageLayout") {
    return <MultiPageLayout guestUser={true}>{children}</MultiPageLayout>;
  } else return <>{children}</>;
};

export default PublicRoute;
